import { observable } from "mobx";
import { EmptyId } from "../../enums";
import { Address } from "../../profile";

export enum EmploymentStatusType {
  Unknown = 0,
  FullTime = 1,
  PartTime = 2,
  NotEmployed = 3,
  Retired = 4,
  Disabled = 5
}

export enum Programs {
  QuickPathToEnergyAndTrades = 0x01,
  QuickPathToTransportation = 0x02,
  SolarWorksDC = 0x04,
  AutoTechnician = 0x08,
  OSHATraining = 0x10,
  FirstAid = 0x20,
  ResumeAssistance = 0x40,
  MockInterview = 0x80
}

export class DCIAApplication {
  @observable id: string;
  @observable seekerId: string;
  @observable name: string;
  @observable date: Date;
  @observable address: Address;
  @observable ward: string;
  @observable email: string;
  @observable phone: string;
  @observable altPhone: string;
  @observable resident: boolean;
  @observable gender: string;
  @observable age: number;
  @observable dob: Date;
  @observable highSchoolGED: boolean;
  @observable casasTest: boolean; // Note: Check punctuation on model
  @observable employmentStatus: EmploymentStatusType;
  @observable hoursWorkedMF: string;
  @observable felony: boolean;
  @observable felonyDesc: string;
  @observable misdemeanor: boolean;
  @observable misdemeanorDesc: string;
  @observable drugScreenConsent: boolean;
  @observable validDriversLicense: boolean;
  @observable safetyViolations: boolean;
  @observable interests: number;

  constructor(app?: DCIAApplication) {
    this.id = this.seekerId = EmptyId;
    this.name = this.ward = this.email = this.phone = this.altPhone = this.gender = this.hoursWorkedMF = this.felonyDesc = this.misdemeanorDesc = "";
    this.date = new Date();
    this.dob = null;
    this.address = new Address();
    this.employmentStatus = EmploymentStatusType.Unknown;
    this.age = 0;
    this.interests = 0;
    this.resident = this.highSchoolGED = this.casasTest = this.felony = this.misdemeanor = this.drugScreenConsent = this.validDriversLicense = this.safetyViolations = false;
  }
}


// WEBPACK FOOTER //
// ./src/models/client/dcia/DCIAApplication.ts